var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        attrs: { "has-line": "", title: "Información de Enmienda" }
      }),
      _c(
        "callout",
        {
          staticClass: "mt-n2",
          attrs: {
            "border-color": "gray-2",
            "class-main": "bg-gray-9",
            "has-gradient": "",
            "has-toggle": false
          }
        },
        [
          _c("div", { staticClass: "row my-2" }, [
            _c(
              "div",
              { staticClass: "d-flex flex-column col-md-3 col-sm-12" },
              [
                _c("span", { staticClass: "data-label mb-1" }, [
                  _vm._v("Número Enmienda:")
                ]),
                _c(
                  "span",
                  { staticClass: "color-black font-16 font-weight-bold" },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.value.contractNumberBase) +
                        _vm._s(_vm.value.contractNumberAdded) +
                        " "
                    )
                  ]
                )
              ]
            ),
            _c(
              "div",
              {
                staticClass:
                  "col-md-9 col-sm-12 d-flex justify-content-end mt-3 mt-md-0"
              },
              [
                _c("div", { staticClass: "bg-white px-4 py-2" }, [
                  _c("span", { staticClass: "data-label" }, [
                    _vm._v("Enmendar:")
                  ]),
                  _c("div", { staticClass: "row py-2" }, [
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("check-box", {
                          attrs: { disabled: _vm.isReadOnly, text: "Vigencia" },
                          model: {
                            value: _vm.value.amendmentTypeDateFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.value, "amendmentTypeDateFlag", $$v)
                            },
                            expression: "value.amendmentTypeDateFlag"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("check-box", {
                          attrs: { disabled: _vm.isReadOnly, text: "Monto" },
                          model: {
                            value: _vm.value.amendmentTypeBalanceFlag,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.value,
                                "amendmentTypeBalanceFlag",
                                $$v
                              )
                            },
                            expression: "value.amendmentTypeBalanceFlag"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col" },
                      [
                        _c("check-box", {
                          attrs: { disabled: _vm.isReadOnly, text: "Otro" },
                          model: {
                            value: _vm.value.amendmentTypeOtherFlag,
                            callback: function($$v) {
                              _vm.$set(_vm.value, "amendmentTypeOtherFlag", $$v)
                            },
                            expression: "value.amendmentTypeOtherFlag"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _vm.showSelectionError
                          ? _c("error", {
                              attrs: {
                                message:
                                  "Favor seleccionar vigencia, monto u otro a enmendar. ",
                                variant: "no-border"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ]
            )
          ])
        ]
      ),
      _vm.showAmendmentReason
        ? _c(
            "div",
            [
              _c("section-title", {
                staticClass: "mt-3",
                attrs: { "has-line": "", title: "Razón de Enmienda" }
              }),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-12 pb-3" },
                  [
                    _c("validation-provider", {
                      attrs: { rules: "required" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function({ errors }) {
                              return [
                                _c("custom-text-area", {
                                  attrs: {
                                    "custom-error-msg":
                                      "Favor completar razón de enmienda.",
                                    disabled: _vm.isReadOnly,
                                    error: errors[0],
                                    maxlength: 3000,
                                    name: "comment",
                                    rows: 1
                                  },
                                  model: {
                                    value: _vm.value.amendmentReason,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.value,
                                        "amendmentReason",
                                        $$v
                                      )
                                    },
                                    expression: "value.amendmentReason"
                                  }
                                })
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2989024460
                      )
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }